import { createFileRoute } from "@tanstack/react-router";
import InvitationsAdminPage from "@/pages/InvitationsAdminPage";

export const Route = createFileRoute("/_app/settings/invitations")({
  component: InvitationsAdminPage,
});
